export const apiConstants = {
  Create: '/services/app/Booking/Create',
  Cancel: '/services/app/Booking/Cancel',
  RemovePlayer: '/services/app/Booking/RemovePlayer',
};
